module.exports = __webpack_public_path__ + "static/media/Katy Driver Headshot_1699374820236.0a37f916.jpeg";